import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-stream-popup",
  templateUrl: "./stream-popup.component.html",
  styleUrls: ["./stream-popup.component.scss"],
})
export class StreamPopupComponent implements OnInit {
  @Input() showStreamPopup = false;
  @Output() fetchChecks = new EventEmitter<string>();

  streams: any[] = []; 
  selectedStream: string = ''; 
  _auth = authData(); 
  notification = {}; 
  loading: boolean = false;

  constructor(private httpClient: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this._auth.Token, 
    }),
  };

  ngOnInit(): void {
    this.getStreams(); 
  }

  getStreams() {
    const baseUrl = `${environment.BASE_URL}/users/GetStreams`; 
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        this.streams = res.Data || [];
      },
      error: (err) => {
        console.error("Error fetching streams:", err);
      },
    });
  }

  submitStream() {
    if (!this.selectedStream) return;
    this.loading = true;

    const baseUrl = `${environment.BASE_URL}/users/SaveStream?streamID=${this.selectedStream}`; 
    this.httpClient.post(baseUrl, {}, this.httpOptions).subscribe({
      next: (res: any) => {
        if (!res.Success) {
          this.loading = false;
          this.notification = {
            error: true,
            message:
              res?.Message || "An error occurred. Please, try again",
          };
        } else {
          this.handleResponse("Stream saved successfully");
        }
      },
      error: (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      },
    });
  }


  handleResponse(message: string) {
    // const auth = sessionStorage.getItem("_auth");
    // if (auth !== null) {
    //   const authObj = JSON.parse(auth);
    //   authObj.ShowStreamPopup = false; 
    //   sessionStorage.setItem("_auth", JSON.stringify(authObj));
    // }
    message ? this.fetchChecks.emit(message) : this.fetchChecks.emit();
  }
}
